import { useNavigate } from "react-router-dom";
import React from "react";
import { SavingCoin } from "./../../Public/assets";
import { ArrowRight } from "lucide-react";
import SavingHeading from "./SavingHeadings";

function ProtectFromDepreciation() {
  const navigate = useNavigate();
  return (
    <div className="pt-10 px-6  lg:flex items-center justify-between xl:px-[134px] lg:py-[100px]">
      <div className="lg:w-1/2 md:mt-18 lg:mt-0">
        <SavingHeading
          firstline={"Savings that are safe"}
          secondline={"from hostile"}
          secondlineBlue={"currency"}
          thirdlineblue={"fluctuations"}
        />
        <h2 className="font-GeomanistRegular font-normal text-[14px] text-geomanistgray md:text-base text-AktivGrotesk leading-[19px] mt-2 md:mt-0 lg:pr-[40px] xxl:pr-[103px]">
          Most emerging market currencies tend to depreciate against the USD,
          GBP, Euro etc. Your users get to save in mature currencies to hedge
          against falls in value.
        </h2>
        <div className=" mt-4 mb-8  md:mb-4 lg:mt-[29px]">
          <button
            className="group relative text-[11px] md:text-xl lg:text-xl font-normal leading-[12px] md:leading-6 font- text-white rounded-[5px] bg-blueish py-2.5 xxl:py-3 px-[13px] xxl:px-5 flex items-center overflow-hidden transition-all duration-700 ease-in-out hover:px-7 max-w-fit font-geomanistMedium"
            onClick={() => {
              navigate("/email");
            }}
          >
            Sign up
            <div className="w-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:w-6 md:group-hover:w-8">
              <ArrowRight className="w-[16px] md:w-[24px] h-[16px] md:h-[24px] opacity-0 translate-x-[-10px] transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:translate-x-0 group-hover:ml-2 font-geomanistMedium" />
            </div>
          </button>
        </div>
      </div>
      <video
        className="rounded-[20px] overflow-hidden h-auto w-auto md:h-[450px] lg:h-[542px] md:w-auto"
        muted
        autoPlay
        loop
        playsInline
      >
        <source src={SavingCoin} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default ProtectFromDepreciation;
